import { Camera } from 'lucide-react';

export const EmptyState = () => (
  <div className="text-center py-16 px-4">
    <div className="bg-blue-50 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-4">
      <Camera size={40} className="text-blue-600" />
    </div>
    <h3 className="text-xl font-bold text-gray-800 mb-2">No Reports Yet</h3>
    <p className="text-gray-500 max-w-xs mx-auto">
      Be the first to submit an evidence-based report documenting public projects in your area.
    </p>
  </div>
);
